<template>
  <div>
    <b-card
      title="Input Groups with Buttons"
      no-body
      class="mb-0 pt-2 pl-2 pr-2"
    >
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-row>
            <b-col
              cols="12"
              md="3"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Fecha Venta"
                rules="required"
              >
                <b-form-group
                  label="Fecha Venta"
                  label-for="fechaVenta"
                >
                  <b-form-datepicker
                    v-model="formData.fechaVenta"
                    locale="es"
                    :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                    :state="getValidationState(validationContext)"
                    :min="fechaMinima"
                    :max="fechaMaxima"
                    trim
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Vendedor"
                rules="required"
              >
                <b-form-group
                  label="Vendedor"
                  label-for="vendedor"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.vendedor"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="nombreCompleto"
                    :options="selectVendedor"
                    :state="getValidationState(validationContext)"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Tipo de Venta"
                rules="required"
              >
                <b-form-group
                  label="Tipo de Venta"
                  label-for="tipoVenta"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.tipoVenta"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="descripcion"
                    :options="selectTipoVenta"
                    :state="getValidationState(validationContext)"
                    @input="getFechaVencimiento()"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Forma de Pago"
                rules="required"
              >
                <b-form-group
                  label="Forma de Pago"
                  label-for="formaPago"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.formaPago"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="descripcion"
                    :options="selectFormaPago"
                    :state="getValidationState(validationContext)"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Tipo de Documento"
                rules="required"
              >
                <b-form-group
                  label="Tipo de Documento"
                  label-for="tipoDocumento"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.tipoDocumento"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="descripcion"
                    :options="selectTipoDocumento"
                    :state="getValidationState(validationContext)"
                    @input="getSeries()"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="RUC / DNI"
                rules="required"
              >
                <b-form-group
                  label="RUC / DNI"
                  label-for="documentoCliente"
                  class="black-text"
                >
                  <b-input-group>
                    <b-form-input
                      id="documentoCliente"
                      ref="documentoCliente"
                      v-model="formData.documentoCliente"
                      type="number"
                      :state="getValidationState(validationContext)"
                      @keydown.enter="buscarCliente"
                    />
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-info"
                        @click.prevent="getSearchDocument('R')"
                      >
                        RUC
                      </b-button>
                      <b-button
                        size="sm"
                        variant="outline-info"
                        @click.prevent="getSearchDocument('D')"
                      >
                        DNI
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="1"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Serie"
                rules="required"
              >
                <b-form-group
                  label="Serie"
                  label-for="serie"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.serie"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="serie"
                    :options="selectSerie"
                    :state="getValidationState(validationContext)"
                    @input="getNroComprobante()"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Nro Comprobante"
                rules="required"
              >
                <b-form-group
                  label="Nro Comprobante"
                  label-for="nro_comprobante"
                  class="black-text"
                >
                  <b-form-input
                    v-model="formData.nro_comprobante"
                    :state="getValidationState(validationContext)"
                    readonly
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Forma de Impresion"
                rules="required"
              >
                <b-form-group
                  label="Forma de Impresion"
                  label-for="forma_print"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.formaPrint"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="descripcion"
                    :options="selectFormaPrint"
                    :state="getValidationState(validationContext)"
                    @input="getNroComprobante()"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Tipo de Pago"
                rules="required"
              >
                <b-form-group
                  label="Tipo de Pago"
                  label-for="tipo_pago"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.tipoPago"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="descripcion"
                    :options="selectTipoPago"
                    :state="getValidationState(validationContext)"
                    @input="changeTipoPago"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="1"
              class="mb-1 mb-md-0"
            >
              <b-form-group
                label="Saldo Fise"
                label-for="saldoFise"
                class="black-text"
              >
                <b-form-input
                  v-model="formData.saldoFise"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="1"
              class="mb-1 mb-md-0"
            >
              <b-form-group
                label="Importe Fise"
                label-for="cantidadFise"
                class="black-text"
              >
                <b-form-input
                  v-model="formData.cantidadFise"
                  :disabled="isFise"
                  :max="formData.saldoFise"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Razon Social"
                rules="required"
              >
                <b-form-group
                  label="Razon Social"
                  label-for="razon_social"
                  class="black-text"
                >
                  <!-- <b-form-input
                    v-model="formData.razon_social"
                    :state="getValidationState(validationContext)"
                  /> -->
                  <v-select
                    v-model="formData.cliente"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="razonSocial"
                    :options="selectCliente"
                    :filterable="false"
                    :loading="loadingCliente"
                    :state="getValidationState(validationContext)"
                    @search="onSearchCliente"
                    @input="selectedCliente()"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Direccion"
                rules="required"
              >
                <b-form-group
                  label="Direccion"
                  label-for="direccion"
                  class="black-text"
                >
                  <b-form-input
                    v-model="formData.direccion"
                    :state="getValidationState(validationContext)"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="1"
              class="mb-1 mb-md-0"
            >
              <b-form-group
                label="Celular"
                label-for="Celular"
                class="black-text"
              >
                <b-form-input
                  v-model="formData.celular"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="email"
              >
                <b-form-group
                  label="Email"
                  label-for="Email"
                  class="black-text"
                >
                  <b-form-input
                    v-model="formData.email"
                    :state="getValidationState(validationContext)"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="email"
              >
                <b-form-group
                  label="Cliente Final"
                  label-for="clienteFinal"
                  class="black-text"
                >
                  <v-select
                    v-model="formData.clienteFinal"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="nombreComercial"
                    :options="selectClienteFinal"
                    :filterable="false"
                    :loading="loadingClienteFinal"
                    :state="getValidationState(validationContext)"
                    @search="onSearchClienteFinal"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="5"
              class="mb-1 mb-md-0"
            >
              <b-form-group
                label="Buscar Producto"
                label-for="producto"
                class="black-text"
              >
                <v-select
                  id="searchProducto"
                  v-model="formData.preProducto"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="productoNombre"
                  :options="selectProducto"
                  @input="changeProducto"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="U. Medida"
                rules="required"
              >
                <b-form-group
                  label="U. Medida"
                  label-for="U. Medida"
                >
                  <v-select
                    v-model="formData.unidadMedida"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="descripcion"
                    :options="selectFormaPrint"
                    :state="getValidationState(validationContext)"
                  />
                </b-form-group>
              </validation-provider>
            </b-col> -->
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <b-form-group
                label="Precio"
                label-for="precio"
                class="black-text"
              >
                <b-form-input
                  id="prePrecio"
                  v-model="formData.prePrecio"
                  type="number"
                  @keydown.enter="leapInput('preCantidad')"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <b-input-group
                v-if="!isVendedorGasocentro"
                style="padding-top: 17px;"
                prepend="Cantidad"
                class="black-text"
              >
                <b-form-input
                  id="preCantidad"
                  v-model="formData.preCantidad"
                  type="number"
                  @keydown.enter="addDetalle"
                />
                <b-input-group-append>
                  <b-button
                    variant="success"
                    class="btn-icon"
                    size="sm"
                    :disabled="isCalcular"
                    @click="calcularCantidadGranel"
                  >
                    <feather-icon icon="PlusSquareIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <b-input-group
                v-if="isVendedorGasocentro"
                style="padding-top: 17px;"
                prepend="Importe"
                class="black-text"
              >
                <b-form-input
                  id="preImporte"
                  v-model="formData.preImporte"
                  type="number"
                  @keydown.enter="addDetalle"
                />
                <b-input-group-append>
                  <b-button
                    variant="success"
                    class="btn-icon"
                    size="sm"
                    :disabled="isCalcular"
                    @click="calcularCantidadGranel"
                  >
                    <feather-icon icon="PlusSquareIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mb-md-0"
            >
              <b-form-group
                label="Unidad M."
                label-for="producto"
                class="black-text"
              >
                <v-select
                  v-model="formData.preUnidadMedida"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="descripcion"
                  :options="selectunidadMedida"
                  @input="changeunidadMedida"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="1"
              class="mb-1 mt-2 mb-md-0"
            >
              <b-col md="6">
                <b-button
                  variant="primary"
                  class="btn-icon"
                  size="sm"
                  @click="addDetalle"
                >
                  <feather-icon icon="PlusSquareIcon" />
                </b-button>
              </b-col>
              <b-col md="6">
                <b-button
                  variant="success"
                  class="btn-icon"
                  size="sm"
                  @click="addDetalleLibre"
                >
                  <feather-icon icon="PlusSquareIcon" />
                </b-button>
              </b-col>
            </b-col>
            <b-col
              cols="12"
              md="7"
              class="mb-1 mb-md-0"
            >
              <b-form-group
                label="Observacion"
                label-for="observacion"
                class="black-text"
              >
                <b-form-input v-model="formData.observacion" />
              </b-form-group>
            </b-col>
            <b-col
              v-if="isVencimiento"
              cols="12"
              md="3"
              class="mb-1 mb-md-0"
            >
              <validation-provider
                #default="validationContext"
                name="Fecha Vencimiento"
                rules="required"
              >
                <b-form-group
                  label="Fecha Vencimiento"
                  label-for="fechaVencimiento"
                  class="black-text"
                >

                  <b-form-datepicker
                    v-model="formData.fechaVencimiento"
                    :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric'}"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <div class="demo-inline-spacing">
                <b-form-radio
                  v-model="modalidad"
                  plain
                  name="modalidad-radio1"
                  value="P"
                >
                  Puerta
                </b-form-radio>
                <b-form-radio
                  v-model="modalidad"
                  plain
                  name="modalidad-radio2"
                  value="D"
                >
                  Delivery
                </b-form-radio>
                <b-form-radio
                  v-model="modalidad"
                  plain
                  name="modalidad-radio3"
                  value="R"
                >
                  Restaurante
                </b-form-radio>
              </div>
            </b-col>
            <b-col
              cols="12"
              md="1"
              class="mt-2"
            >
              <b-form-checkbox
                v-model="isIgv"
                name="check-button"
                switch
                :disabled="!isVentaExterna"
                inline
              >
                IGV?
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="mb-1 mt-2 mb-md-0"
            >
              <b-table
                ref="refUserListTable"
                class="position-relative"
                :items="items"
                responsive
                :fields="fieldsDetalle"
                primary-key="id"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No se encontraron registros"
                :busy="isBusy"
              >
                <!-- Column: precio -->
                <template #cell(productoNombre)="data">
                  <b-form-input
                    v-if="!data.item.isService"
                    v-model="data.item.productoNombre"
                    disabled="true"
                    size="sm"
                  />
                  <b-form-input
                    v-if="data.item.isService"
                    v-model="data.item.productoNombre"
                    size="sm"
                  />
                </template>
                <template #cell(inputUnidadMedida)="data">
                  <v-select
                    v-model="data.item.unidadMedida"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="descripcion"
                    :options="[data.item.unidadMedida]"
                    disabled
                    class="select-size-sm"
                  />
                </template>
                <!-- Column: precio -->
                <template #cell(inputPrecio)="data">
                  <b-form-input
                    v-model="data.item.precio"
                    size="sm"
                    type="number"
                    step="any"
                    @input="changeCantidadPrecio(data.item,'P')"
                  />
                </template>
                <!-- Column: precio -->
                <template #cell(inputPrecioVenta)="data">
                  <b-form-input
                    v-model="data.item.precioVenta"
                    size="sm"
                    :disabled="!isVentaExterna"
                    type="number"
                    step="any"
                    @input="changeCantidadPrecio(data.item,'PV')"
                  />
                </template>
                <!-- Column: Cantidad -->
                <template #cell(inputCantidad)="data">
                  <b-form-input
                    v-model="data.item.cantidad"
                    type="number"
                    size="sm"
                    step="any"
                    @input="changeCantidadPrecio(data.item,'C')"
                  />
                </template>
                <!-- Column: Subtotal -->
                <template #cell(inputSubtotal)="data">
                  <b-form-input
                    v-model="data.item.subtotal"
                    readonly
                    size="sm"
                  />
                </template>
                <!-- Column: Actions -->
                <template #cell(acciones)="data">
                  <b-dropdown
                    variant="link"
                    no-caret
                    :right="$store.state.appConfig.isRTL"
                  >

                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>
                    <b-dropdown-item
                      @click="deleteDetalle(data.item)"
                    >
                      <feather-icon icon="XSquareIcon" />
                      <span class="align-middle ml-50">Eliminar</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="6"
            />
            <b-col
              cols="12"
              md="2"
              class="mb-1 mt-1 mb-md-0"
            >
              <b-form-group
                label="SubTotal"
                label-for="subtotal"
                class="black-text"
              >
                <b-form-input
                  v-model="formData.subTotal"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mt-1 mb-md-0"
            >
              <b-form-group
                label="Igv"
                label-for="igv"
                class="black-text"
              >
                <b-form-input
                  v-model="formData.igv"
                  readonly
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class="mb-1 mt-1 mb-md-0"
            >
              <b-form-group
                label="Total"
                label-for="total"
                class="black-text"
              >
                <b-form-input
                  v-model="formData.total"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="6"
            />
            <b-col
              cols="12"
              md="2"
              class="mb-md-0"
            />
            <b-col
              cols="12"
              md="2"
              class=" mb-md-0"
            >
              <b-form-group
                label="Efectivo"
                label-for="Efectivo"
                class="black-text"
              >
                <b-form-input
                  id="efectivo"
                  v-model="formData.efectivo"
                  type="number"
                  @input="calcularVuelto"
                  @keydown.enter="handleSubmit(onSubmit)"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="2"
              class=" mb-md-0"
            >
              <b-form-group
                label="Vuelto"
                label-for="Vuelto"
                class="black-text"
              >
                <b-form-input
                  v-model="formData.vuelto"
                  readonly
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            class="text-center"
            align-v="center"
          >
            <b-col
              cols="12"
              md="4"
            />
            <b-col
              cols="12"
              md="4"
            >
              <b-button
                variant="primary"
                class="btn-icon"
                type="button"
                size="lg"
                @click="handleSubmit(onSubmit)"
              >
                Guardar
                <feather-icon icon="SaveIcon" />
              </b-button>
            </b-col>
            <b-col
              cols="12"
              md="4"
            />
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  BCard, VBTooltip, BCol, BRow, BFormGroup, BForm, BFormInput, BInputGroup, BInputGroupAppend, BButton, BTable, BDropdown, BDropdownItem, BFormDatepicker, BFormRadio,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref, computed } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import vSelect from 'vue-select'
import { useNotify } from '@/helpers/toast'
// import Ripple from 'vue-ripple-directive'
import store from '@/store'
import moment from 'moment'
import { jsPDF } from 'jspdf'
import QRCode from 'qrcode'

export default {
  components: {
    BCard,
    // BFormDatepicker,
    BFormRadio,
    BCol,
    BRow,
    BFormGroup,
    BForm,
    vSelect,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BTable,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    BFormCheckbox,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      required,
    }
  },
  setup(props, context) {
    const userData = ref(JSON.parse(localStorage.getItem('userData')))
    const { notify } = useNotify(context)
    const titleForm = ref('')
    const sortBy = ref(null)
    const isIgv = ref(false)
    const isVentaExterna = ref(false)
    const isBusy = ref(false)
    const modalidad = ref('P')
    // .toISOString().split('T')[0],
    const blankData = {
      fechaVenta: moment().format('YYYY-MM-DD'),
      fechaVencimiento: null,
      vendedor: 0,
      tipoVenta: { descripcion: 'CONTADO', estado: true, tipoVentaId: 2 },
      formaPago: { descripcion: 'EFECTIVO', estado: true, formaPagoId: 1 },
      formaPrint: { descripcion: 'TICKET' },
      tipoDocumento: 0,
      serie: 0,
      igv: 0,
      subTotal: 0,
      total: 0,
      nro_comprobante: '',
      razon_social: 'CLIENTE VARIOS',
      documentoCliente: '00000000',
      direccion: '-',
      efectivo: 0,
      vuelto: 0,
      observacion: '',
      email: '',
      clienteFinal: null,
      tipoPago: { descripcion: 'COMPLETO' },
      cantidadFise: 0,
      saldoFise: 0,
      preCantidad: 0,
      preImporte: 0,
      celular: '',
      cliente: { idCliente: 0, documento: '00000000', razonSocial: 'CLIENTES VARIOS', direccion: '-', nombreComercial: 'CLIENTES 11' },
    }
    const presentaciones = ref([])
    const selectClienteFinal = ref([])
    const selectCliente = ref([])
    const loadingClienteFinal = ref(false)
    const loadingCliente = ref(false)
    const presentacionSel = ref({})
    const isVencimiento = ref(false)
    const isCalcular = ref(true)
    const isFise = ref(true)
    const items = ref([])
    const fieldsDetalle = ref([
      { key: 'idDetalle', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
      { key: 'productoNombre', label: 'Producto', sortable: true, thStyle: { width: '35%' } },
      { key: 'inputUnidadMedida', label: 'Unidad M.', thStyle: { width: '18%' } },
      { key: 'inputPrecioVenta', label: 'Valor venta (sin iGV)', thStyle: { width: '14%' } },
      { key: 'inputPrecio', label: 'Precio Venta', thStyle: { width: '14%' } },
      { key: 'inputCantidad', label: 'Cantidad', thStyle: { width: '14%' } },
      { key: 'inputSubtotal', label: 'Subtotal', thStyle: { width: '14%' } },
      { key: 'acciones', thStyle: { width: '5%' } },
    ])
    const formData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }
    const selectVendedor = ref([])
    const selectTipoVenta = ref([])
    const selectFormaPago = ref([])
    const selectTipoDocumento = ref([])
    const selectSerie = ref([])
    const selectunidadMedida = ref([])
    const userProfile = ref(localStorage.getItem('userProfile'))
    const selectFormaPrint = ref([
      { descripcion: 'A4' },
      { descripcion: 'A5' },
      { descripcion: 'TICKET' },
    ])
    const selectTipoPago = ref([
      { descripcion: 'COMPLETO' },
      { descripcion: 'BONO_FISE' },
    ])
    const selectProducto = ref([])
    const getNroComprobante = async () => {
      await store.dispatch('comercial/GET_NRO_COMPROBANTE', { tipo_documento_id: formData.value.tipoDocumento.tipoDocumentoId, serie_id: formData.value.serie.serieId,
      })
        .then(response => {
          // Vue.swal.close()
          if (response) {
            // console.log(formData.value.nro_comprobante)
            formData.value.nro_comprobante = response.nroDocumento
            // console.log(formData.value.nro_comprobante)
          }
        })
    }
    const getSeries = async data => {
      console.log(data)
      await store.dispatch('comercial/GET_SERIES', { tipo_documento_id: formData.value.tipoDocumento.tipoDocumentoId,
      })
        .then(response => {
          if (response) {
            selectSerie.value = response
          }
          selectSerie.value.forEach((element, index) => {
            if (index === 0) {
              formData.value.serie = element
            }
          })
          getNroComprobante()
        })
    }
    const calculoGranel = data => {
      console.log(data)
    }
    const calcularCantidadGranel = () => {
      Vue.swal({
        title: 'Calcular Cantidades',
        html: '<input type="number" id="cantidadC" class="form-control" placeholder="Cantidad"> <input type="number" id="percioC" class="form-control" placeholder="Precio"> <input type="number" id="convercionC" class="form-control" placeholder="Conversion">',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Carcular',
        cancelButtonText: 'Cerrar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-danger  ml-1',
        },
        buttonsStyling: false,
        preConfirm: () => {
          console.log(Vue.swal.getPopup())
          const cantidadC = Vue.swal.getPopup().querySelector('#cantidadC')
          const precioC = Vue.swal.getPopup().querySelector('#precioC')
          const conversionC = Vue.swal.getPopup().querySelector('#conversionC')
          console.info('acaa', cantidadC, precioC, conversionC)
          if (cantidadC === '') {
            Vue.swal.showValidationMessage('Tiene que ingresar la cantiad')
          }
          if (precioC === '') {
            Vue.swal.showValidationMessage('Tiene que ingresar la precio')
          }
          if (conversionC === '') {
            Vue.swal.showValidationMessage('Tiene que ingresar la conversion')
          }
        },
      }).then(result => {
        if (result.value) {
          console.log(result)
        }
      })
    }
    const tienePerfil = nombrePerfil => {
      const lista = JSON.parse(localStorage.getItem('listPerfiles'))
      return lista.some(item => item.perfil === nombrePerfil)
    }
    const getParametros = async () => {
      if (userData.value.authorities[0].authority === 'VENDEDOR GRANEL') {
        isCalcular.value = false
      }

      isVentaExterna.value = userData.value.authorities[0].authority === 'CONTADOR'
      // console.info('isCalcular', isCalcular.value, userData.value.authorities[0].authority)
      Vue.swal({
        title: 'Obteniendo Parametros',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          Vue.swal.showLoading()
          await store.dispatch('comercial/VENTAS_PARAMETERS', { tipo: 'web' })
            .then(response => {
              // console.log(response)
              if (response) {
                presentaciones.value = response
                selectFormaPago.value = response.forma_pago
                selectTipoDocumento.value = []
                response.tipo_documento.forEach(row => {
                  if (row.venta) {
                    selectTipoDocumento.value.push(row)
                    if (row.tipoDocumentoId === 2) {
                      formData.value.tipoDocumento = row
                    }
                  }
                })
                selectTipoVenta.value = response.tipo_venta
                // selectClienteFinal.value = response.cliente
                getSeries(formData.value.tipoDocumento)
              }
            })
          await store.dispatch('facturacion/GET_PRODUCTO_SEARCH_FACTURACION', { limit: 30, page: -1, query: '', sortBy: '' })
            .then(response => {
              response.items.forEach(value => {
                const row = value
                row.productoNombre = `${value.codigoEmpresa == null ? '' : value.codigoEmpresa} ${value.presentacion.descripcion} - ${value.presentacion.marca.descripcion}`
                selectProducto.value.push(row)
              })
            })
          console.log(userData.value.authorities[0].authority)
          // userData.value.authorities[0].authority === 'VENDEDOR NCAJAMARCA' || userData.value.authorities[0].authority === 'VENDEDOR CILINDROS' || userData.value.authorities[0].authority === 'VENDEDOR GRANEL' || userData.value.authorities[0].authority === 'VENDEDOR DEPOSITO' || userData.value.authorities[0].authority === 'VENDEDOR GASOCENTRO' || userData.value.authorities[0].authority === 'CONTADOR'
          if (tienePerfil(userData.value.authorities[0].authority)) {
            selectVendedor.value.push({ idUsuario: userData.value.id, nombreCompleto: userData.value.nombreCompleto })
            formData.value.vendedor = { idUsuario: userData.value.id, nombreCompleto: userData.value.nombreCompleto }
          } else {
            selectVendedor.value = []
            await store.dispatch('seguridad/USUARIO_ALL_SALES', { tipo_usuario: '-' })
              .then(response => {
                response.forEach((value, index) => {
                  const { trabajador, ...resto } = value
                  const nuevoObjeto = {
                    nombreCompleto: trabajador.nombreCompleto,
                    ...resto,
                    trabajador,
                  }
                  selectVendedor.value.push(nuevoObjeto)
                  if (index === 0) {
                    // formData.value.vendedor = nuevoObjeto
                  }
                })

                selectVendedor.value.push({ idUsuario: userData.value.id, nombreCompleto: userData.value.nombreCompleto })
                formData.value.vendedor = { idUsuario: userData.value.id, nombreCompleto: userData.value.nombreCompleto }
              })
          }
          // document.querySelector("#documentoCliente").focus()
          Vue.swal.close()
          Vue.nextTick(() => {
            const input = document.querySelector('#documentoCliente')
            if (input) input.focus()
          })
        },
      })
    }
    const getFechaConHoraActual = () => {
      const [year, month, day] = formData.value.fechaVenta.split('-') // "2025-08-05" → [2025, 08, 05]
      const ahora = new Date()

      // Crear fecha con componentes locales (mes empieza en 0)
      const fecha = new Date(
        parseInt(year, 10),
        parseInt(month, 10) - 1,
        parseInt(day, 10),
        ahora.getHours(),
        ahora.getMinutes(),
        ahora.getSeconds(),
      )

      // Formatear a "dd/MM/yyyy HH:mm:ss"
      const dia = String(fecha.getDate()).padStart(2, '0')
      const mes = String(fecha.getMonth() + 1).padStart(2, '0')
      const anio = fecha.getFullYear()
      const horas = String(fecha.getHours()).padStart(2, '0')
      const minutos = String(fecha.getMinutes()).padStart(2, '0')
      const segundos = String(fecha.getSeconds()).padStart(2, '0')

      return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`
    }
    const formParse = () => {
      const form = {
        sunatVenta: {},
        detalleVentas: [],
      }
      let clienteFinalParse = null
      if (formData.value.clienteFinal) {
        const { ubigeoAll, ...rest } = formData.value.clienteFinal
        clienteFinalParse = rest
      }
      // formData.value.fechaVenta,dd/MM/yyyy hh:mm:ss
      const sunatVenta = { almacen: { almacenId: formData.value.vendedor.id },
        clienteDato: `${formData.value.razon_social}|${formData.value.direccion}|${formData.value.documentoCliente}|${formData.value.celular}`,
        clienteId: formData.value.cliente != null ? formData.value.cliente.idCliente : 0,
        email: formData.value.email,
        envio: true,
        estado: true,
        fechaVenta: getFechaConHoraActual(),
        fechaVencimiento: formData.value.fechaVencimiento,
        formatoImpresion: formData.value.formaPrint.descripcion,
        formatoPago: formData.value.formaPago,
        igv: 0,
        latitud: 'oficina',
        longitud: 'oficina',
        montoIgv: formData.value.igv,
        numeroComprobante: formData.value.nro_comprobante,
        observacion: formData.value.observacion,
        sub_total: formData.value.subTotal,
        tipoDocumento: formData.value.tipoDocumento,
        tipoMoneda: { tipoMonedaId: 1 },
        tipoVenta: formData.value.tipoVenta,
        total: formData.value.total,
        vendedorId: 0,
        ventaId: 0,
        tipoPago: formData.value.tipoPago.descripcion,
        cantidadFise: 0,
        totalFise: formData.value.tipoPago.descripcion === 'BONO_FISE' ? formData.value.cantidadFise : 0,
        clienteFinal: clienteFinalParse,
        modalidad: modalidad.value,
        efectivo: formData.value.efectivo,
      }
      form.sunatVenta = sunatVenta
      items.value.forEach(element => {
        console.info('DETALLE ROW', element)
        const row = {
          cantidad: element.cantidad,
          detalleVentaId: 0,
          estado: true,
          igv: element.igv,
          observacion: '',
          precio: element.precio,
          productoDato: element.productoNombre,
          productoId: element.idProducto,
          subTotal: element.subtotal,
          sunatVenta: { ventaId: 0 },
          tipo: 'VENDIDO',
          unidadMedidaDato: element.unidadMedida.abreviatura,
          unidadMedidaId: 0,
          valorVenta: isIgv ? element.precioVenta : element.precio,
        }
        form.detalleVentas.push(row)
      })
      // console.log(JSON.stringify(form))
      return (form)
    }

    const imprimirPDF = urlPDF => {
      const printWindow = window.open(urlPDF, '_blank')

      if (printWindow) {
        printWindow.focus()

        // Espera a que el contenido cargue antes de imprimir
        printWindow.onload = () => {
          printWindow.print()
        }
      } else {
        notify('Error', 'El navegador bloqueó la ventana emergente. Por favor, permite ventanas emergentes para este sitio.', 'danger')
      }
    }
    const convertirNumeroALetras = num => {
      const unidades = ['', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve']
      const decenas = ['', 'diez', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa']
      const centenas = ['', 'cien', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos']
      const n = parseInt(num, 10)

      if (n < 10) return unidades[n]
      if (n < 100) return decenas[Math.floor(n / 10)] + (n % 10 !== 0 ? ` y ${unidades[n % 10]}` : '')
      if (n < 1000) return centenas[Math.floor(n / 100)] + (n % 100 !== 0 ? ` ${convertirNumeroALetras(n % 100)}` : '')
      if (n < 1000000) {
        const miles = Math.floor(n / 1000)
        const resto = n % 1000
        return (miles === 1 ? 'mil' : `${convertirNumeroALetras(miles)} mil`) + (resto !== 0 ? ` ${convertirNumeroALetras(resto)}` : '')
      }

      return 'Número demasiado grande'
    }
    const getPrintPdfTicke = async data => {
      // console.info('aca antes de imprimir', data)
      const row = data.result
      row.repuestaOse = data.respuesta_ose
      row.detalleVenta = data.detalle
      // console.log(row)
      // eslint-disable-next-line new-cap
      const doc = new jsPDF('p', 'mm', [80, 566.93], true)
      doc.setProperties({
        title: 'FACTURACION ELECTRONICA PERU',
        author: 'UNIGAS',
        creator: 'UNIGAS',
      })
      const postx = 5
      let posty = 10
      doc.setFontSize(13)
      doc.addImage(row.almacen.img, 'JPEG', postx + 5, posty - 5, 60, 23)
      doc.setFontSize(9)
      posty += 30
      // y=y-4;
      doc.setFont('helvetica', 'bold')
      doc.text(`${'UNIVERSAL GAS S.R.LTDA.'}`, postx + 15, posty - 8)
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(8)
      const direccion = (row.almacen.direccion).toUpperCase()
      const direccionLines = doc.splitTextToSize(direccion, 75)
      doc.text(direccionLines, postx, posty - 4)
      // doc.text((row.almacen.direccion).toUpperCase(), postx, posty + 4)
      doc.setFontSize(8)
      // let type_comprobante = `${(data[0].tipo_comprobante).toUpperCase()} DE VENTA ELECTRÓNICA    ${documento_vent}`
      // if (data[0].tipo_comprobante == 'FACTURA') {
      //   type_comprobante = `${(data[0].tipo_comprobante).toUpperCase()} ELECTRÓNICA    ${documento_vent}`
      // }
      // posty += 4
      doc.setFont('helvetica', 'bold')
      doc.text(`RUC ${row.almacen.ruc}`, postx + 22, posty + 3)
      doc.setFont('helvetica', 'normal')
      doc.text('Cel. 941900064 Cel. 941900060', postx + 12, posty + 7)
      doc.setFontSize(9)
      doc.setFont('helvetica', 'bold')
      const pageWidth = doc.internal.pageSize.getWidth()
      doc.text(row.tipoDocumento.descripcion, pageWidth / 2, posty + 11, { align: 'center' })
      doc.setFontSize(8)
      doc.text(row.numeroComprobante, pageWidth / 2, posty + 15, { align: 'center' })
      doc.text('ADQUIRIENTE ', postx, posty + 19)
      doc.setFont('helvetica', 'normal')
      const clientePart = (row.clienteDato).split('|')
      let clienteDocumento = ''
      if (clientePart[2].length === 8) {
        clienteDocumento = 'DNI'
      }
      if (clientePart[2].length === 11) {
        clienteDocumento = 'RUC'
      }
      doc.text(`${clienteDocumento} : ${clientePart[2]}`, postx, posty + 23)
      doc.text(`${clientePart[0]}`, postx, posty + 26)
      const direccionLinesCliente = doc.splitTextToSize(clientePart[1], 70)
      doc.text(direccionLinesCliente, postx, posty + 29)
      doc.setFont('helvetica', 'bold')
      // posty -= 4
      doc.text('FECHA EMISIÓN:', postx, posty + 36)
      doc.text('FECHA DE VENC:', postx, posty + 40)
      doc.text('MONEDA:', postx, posty + 44)
      doc.text('FORMA PAGO :', postx + 25, posty + 44)
      doc.setFont('helvetica', 'normal')
      doc.text(row.fechaVenta, postx + 25, posty + 36)
      if (row.fechaVencimiento === null) {
        doc.text(`${moment(row.fechaVenta, 'DD/MM/YYYY').format('DD/MM/YYYY')}`, postx + 25, posty + 40)
      } else {
        doc.text(`${moment(row.fechaVencimiento, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD/MM/YYYY')}`, postx + 25, posty + 40)
      }
      doc.text('SOL', postx + 15, posty + 44)
      doc.text(row.formatoPago.descripcion, postx + 47, posty + 44)
      // Línea separadora en gris claro
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, posty + 45, 75, posty + 45)
      // doc.setFontType("normal");
      // doc.text((data[0].tipopago).toUpperCase(), x + 45, y + 28);
      /* if ((data.tipoventa).toUpperCase() !="CREDITO") {
          doc.text(data.formapago, x + 55, y + 28);
      } */
      // doc.text('---------------------------------------------------------------------', postx, posty + 32)
      posty += 12
      doc.setFontSize(7.5)
      doc.setFont('helvetica', 'bold')
      doc.text('[ CANT. ]', postx, posty + 36.5)
      doc.text('DESCRIPCION', postx + 13, posty + 36.5)
      doc.text('P/U', postx + 50, posty + 36.5)
      doc.text('TOTAL', postx + 62, posty + 36.5)
      doc.setFont('helvetica', 'normal')
      doc.setFontSize(9)
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, posty + 38, 75, posty + 38)
      // doc.text('---------------------------------------------------------------------', postx, posty + 40)
      // doc.setFontType("normal");
      // doc.setFontType("blob");
      let f = posty + 42
      const rows = (row.detalleVenta).length
      doc.setFontSize(7)
      for (let i = 0; i < rows; i += 1) {
        const detVenta = row.detalleVenta[i]
        const producto = `[ ${detVenta.cantidad} ] ${detVenta.unidadMedidaDato} ${detVenta.productoDato}` // nombre_producto;
        // const cantidad = 1
        const pv = parseFloat(detVenta.precio).toFixed(2)
        const st = parseFloat(detVenta.subTotal).toFixed(2)
        // const undm = 'und'
        const productoLines = doc.splitTextToSize(producto, 45)
        // doc.text(`${parseFloat(cantidad).toFixed(2)} ${undm}`, postx, f)
        doc.text(productoLines, postx, f)
        doc.text(`${pv}`, postx + 50, f)
        doc.text(`${st}`, postx + 62, f)
        doc.setFontSize(7)
        // if (is_observacion_detalle == 1) {
        //   if (data[i].otra_observacion != '' && data[i].otra_observacion != null) {
        //     producto += `(${data[i].otra_observacion})`
        //   }
        // }
        // f = jspdf_responsi(doc, producto, postx + 14, f, 25)
        // f -= 4
        // doc.setFontSize(8);
        f += 6.5
      }
      // f += 8
      // doc.text('--------------------------------------------------------------------', postx, f)
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, f, 75, f)
      doc.setFontSize(8)
      // doc.setFontType("normal");
      let textCodeQr = `20362013802 | ${row.tipoDocumento.codigo} | ${row.numeroComprobante} | 0.00 | ${row.total} | ${moment(row.fechaVenta, 'DD/MM/YYYY').format('DD/MM/YYYY')} | 12 | ${clientePart[2]} |`
      if (row.tipoDocumento.tipoDocumentoId !== 12) {
        console.log(row)
        textCodeQr = row.repuestaOse.cadena_para_codigo_qr
      }
      const barcode = await QRCode.toDataURL(textCodeQr)
      const letraTotal = convertirNumeroALetras(row.total)
      const decimales = row.total.toFixed(2).split('.')[1]
      doc.setFontSize(8)
      // doc.text('', postx + 8, f + 4)
      f += -2
      doc.setFont('helvetica', 'bold')
      doc.text('Op. Exonerada:', postx + 27, f + 6)
      doc.text('S/ ', postx + 52, f + 6)
      doc.text(parseFloat(row.sub_total).toFixed(2), postx + 60, f + 6)

      doc.text('Op. Inafecta:', postx + 27, f + 10)
      doc.text('S/ ', postx + 52, f + 10)
      doc.text('0.00', postx + 60, f + 10)

      doc.text('Op. Gravada:', postx + 27, f + 14)
      doc.text('S/ ', postx + 52, f + 14)
      doc.text(parseFloat(0).toFixed(2), postx + 60, f + 14)

      doc.text('IGV:', postx + 27, f + 18)
      doc.text('S/', postx + 52, f + 18)
      doc.text(parseFloat(row.igv).toFixed(2), postx + 60, f + 18)

      doc.text('TOTAL:', postx + 27, f + 22)
      doc.text('S/', postx + 52, f + 22)
      doc.text(parseFloat(row.total).toFixed(2), postx + 60, f + 22)
      let recibido = row.efectivo === undefined ? row.total : row.efectivo
      recibido = recibido == null ? row.total : row.efectivo
      doc.text('RECIBIDO:', postx + 27, f + 26)
      doc.text('S/', postx + 52, f + 26)
      doc.text(parseFloat(recibido).toFixed(2), postx + 60, f + 26)
      const vuelto = recibido - row.total
      doc.text('VUELTO:', postx + 27, f + 30)
      doc.text('S/', postx + 52, f + 30)
      doc.text(parseFloat(vuelto < -1 ? 0 : vuelto).toFixed(2), postx + 60, f + 30)
      doc.setFont('helvetica', 'normal')
      // f += 10
      doc.setDrawColor(200, 200, 200)
      doc.setLineWidth(0.3)
      doc.line(5, f + 32, 75, f + 32)
      doc.setFontSize(7)
      const sonText = doc.splitTextToSize(`SON: ${letraTotal.toUpperCase()} CON ${decimales}/100 SOLES`, 70)
      const numLineas = sonText.length
      doc.text(sonText, postx, f + 35)
      doc.setFont('helvetica', 'bold')
      doc.text(`TIPO DE PAGO : [${row.tipoVenta.descripcion}]`, postx, f + 37 + (numLineas * 2))
      if (row.tipoVenta.tipoVentaId === 1) {
        doc.text(`CUOTA 1 ${moment(row.fechaVencimiento, 'YYYY-MM-DDTHH:mm:ss.SSSZ').format('DD/MM/YYYY')}(S/${row.total})`, postx, f + 40 + (numLineas * 2))
        f += 7
      } else {
        f += 5
      }
      if (row.observacion !== '') {
        const observacionText = doc.splitTextToSize(`OBSERVACION: ${row.observacion.toUpperCase()}`, 70)
        doc.text(`${observacionText}`, postx, f + 37 + (observacionText.length * 2))
        f += 7
      } else {
        f += 5
      }
      doc.setFont('helvetica', 'normal')
      // doc.setFontType("normal");
      doc.setFontSize(8)
      // doc.text("VEND: " + data.vendedor, x, f + 32);
      // doc.text("CAJE: " + data[0].usuario, x, f + 36);
      if (textCodeQr !== '') {
        doc.addImage(barcode, 'JPG', postx + 17, f + 37, 35, 35)
        // doc.setFontType("normal");
        f += 30
      } else {
        f += 5
      }
      // doc.text("DELIVERY SIN COSTO. ATENCION : 8AM - 9PM", x, f + 40);
      /* if (is_placa ==0) {
        doc.text('OBS:', x, f + 44);
    }else{
        doc.text('PLACA:', x, f + 44);
    }

    var initr = f+12;
     if(data[0].observacion != ''){

         $lineas_observaciones = data[0].observacion.split('<br>');
         $tam_observaciones = $lineas_observaciones.length;

         for ($j=0; $j < $tam_observaciones ; $j++) {

             $texto_observacion = $lineas_observaciones[$j];
             doc.text($texto_observacion, 23, initr);
             initr=parseInt(initr) + 12;
         }

     } */
      // f =initr;
      doc.setFontSize(8)
      const textDobleLinea = doc.splitTextToSize(`Representación impresa de la ${row.tipoDocumento.descripcion}, visite`, 70)
      doc.text(textDobleLinea, postx, f + 44)
      doc.setFont('helvetica', 'bold')
      doc.text('www.nubefact.com/20362013802', postx + 17, f + 48)
      doc.setFont('helvetica', 'normal')
      doc.text('No.034-005-0005315 Resumen: ', postx, f + 52)
      doc.text('/IjJCSwwC4Qx98g89jkTi4MFUTBEi6fARYeetox3lWA=', postx, f + 56)
      doc.text('!GRACIAS POR SU COMPRA!', postx + 15, f + 60)
      doc.setFontSize(7.5)
      // doc.save(documento_vent+".pdf");
      const blob = doc.output('blob')
      window.open(URL.createObjectURL(blob))
    }
    const onSubmit = async () => {
      try {
        if (formData.value.tipoPago.descripcion === 'BONO_FISE') {
          if (formData.value.cantidadFise === null || formData.value.cantidadFise === 0 || formData.value.cantidadFise === '') {
            throw new Error('TIENE QUE INGRESAR EL MONTO FISE')
          }

          if (Number(formData.value.cantidadFise) > Number(formData.value.saldoFise)) {
            throw new Error('SU IMPORTE FISE EXCESE EL SALDO DISPONIBLE')
          }
        }

        Vue.swal({
          title: 'Registrando la venta',
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          onOpen: async () => {
            Vue.swal.showLoading()
            const service = 'comercial/VENTA_CREATE'
            // formData.value.presentacion = presentacionSel.value
            await store.dispatch(service, formParse())
              .then(response => {
                Vue.swal.close()
                notify('Respuesta', response.message, 'success')
                items.value = []
                resetData()
                if (response.respuesta_ose) {
                  if (response.respuesta_ose.rutaPdf !== undefined) {
                    imprimirPDF(response.respuesta_ose.rutaPdf)
                  }
                }
                getPrintPdfTicke(response)
                window.location.reload()

                // getParametros()
                // Vue.nextTick(() => {
                //   const inputd = document.querySelector('#documentoCliente')
                //   if (inputd) {
                //     inputd.focus()
                //   }
                // })
              })
              .catch(error => {
                Vue.swal.close()
                notify('Error', error?.response?.data?.errorMessage, 'danger')
                // throw new Error(error?.response?.data?.errorMessage)
              })
          },
        })
      } catch (error) {
        Vue.swal.close()
        notify('Error', error.message, 'danger')
      }
    }

    const calcularVuelto = () => {
      const vuelto = formData.value.total - formData.value.efectivo
      formData.value.vuelto = 0
      if (vuelto <= 0) {
        formData.value.vuelto = vuelto * -1
      }
    }
    const getsaldoCliente = async idCliente => {
      await store
        .dispatch('comercial/CONTROL_FISE_SALDO_ALL', {
          tipo: 'grilla',
          limit: 10,
          query: '',
          page: '-1',
          sortBy: '',
          cliente_id: idCliente,
        })
        .then(response => {
          // this.items = response.items.map(venta => ({ ...venta, clienteRuc: venta.venta.clienteDato.split('|')[2], clienteNombre: venta.venta.clienteDato.split('|')[0] }))
          if (response.items.length > 0) {
            formData.value.saldoFise = parseFloat(response.items[0].saldo - response.items[0].consumido).toFixed(2)
            console.log(response.items)
          }
        })
        .catch(error => {
          this.showToast('Ha ocurrido un error', error, 'danger')
        })
    }
    const getSearchDocument = async tDocumento => {
      // this.isBusy = true
      await store
        .dispatch('comercial/CLIENTE_SEARCH_DOCUMENTO', {
          documento: formData.value.documentoCliente,
          tipo_documento: tDocumento,
        })
        .then(async response => {
          // console.log(response)
          formData.value.cliente = response.data
          formData.value.razon_social = response.data.razonSocial
          formData.value.direccion = response.data.direccion
          formData.value.celular = response.data.celular
          if (formData.value.tipoPago.descripcion === 'BONO_FISE') {
            await getsaldoCliente(formData.value.cliente.idCliente)
          }
          // FACTURAS
          if (formData.value.documentoCliente.length === 11) {
            selectTipoDocumento.value.forEach(row => {
              if (row.tipoDocumentoId === 1) {
                formData.value.tipoDocumento = row
              }
            })
            getSeries(formData.value.tipoDocumento)
          }
          // BOLETAS
          if (formData.value.documentoCliente.length === 8) {
            selectTipoDocumento.value.forEach(row => {
              if (row.tipoDocumentoId === 2) {
                formData.value.tipoDocumento = row
              }
            })
            getSeries(formData.value.tipoDocumento)
          }

          Vue.nextTick(() => {
            setTimeout(() => {
              const vSelectWrapper = document.querySelector('#searchProducto')
              const inputCliente = vSelectWrapper?.querySelector('input')
              if (inputCliente) inputCliente.focus()
            }, 100) // puedes ajustar a 150ms si sigue fallando
          })
        })
        .catch(error => {
          console.log(error)
          notify('Error', error.message, 'danger')
        })
      // this.isBusy = false
    }
    const buscarCliente = () => {
      try {
        const doc = formData.value.documentoCliente
        if (!doc || doc.length === 0) {
          throw new Error('Ingrese un número de documento')
        }

        if (doc.length === 8) {
          getSearchDocument('D') // DNI
        } else if (doc.length === 11) {
          getSearchDocument('R') // RUC
        } else {
          throw new Error('El documento debe tener 8 (DNI) o 11 (RUC) dígitos')
        }
      } catch (error) {
        notify('Error', error.message, 'danger')
      }
    }
    const changeProducto = () => {
      // console.log(formData.value.preProducto)
      formData.value.prePrecio = (formData.value.preProducto.precioDefault).toFixed(3)
      selectunidadMedida.value = []
      // 1 es unidad y 2 es galon,kg
      if (formData.value.preProducto.presentacion.tipoProducto === 1) {
        selectunidadMedida.value = [{ descripcion: 'UNIDAD', abreviatura: 'NIU', convercion: 1 }]
        formData.value.preUnidadMedida = { descripcion: 'UNIDAD', abreviatura: 'NIU', convercion: 1 }
      }
      if (formData.value.preProducto.presentacion.tipoProducto === 2) {
        selectunidadMedida.value = [{ descripcion: 'GALONES', abreviatura: 'GLL', convercion: 10.018 }, { descripcion: 'LITRO', abreviatura: 'LTR', convercion: 2.018 }, { descripcion: 'KILOGRAMOS', abreviatura: 'KGM', convercion: 3.78541 }]
        formData.value.preUnidadMedida = { descripcion: 'GALONES', abreviatura: 'GLL', convercion: 2.018 }
        if (formData.value.preProducto.presentacion.idPresentacion === 14) {
          formData.value.preUnidadMedida = { descripcion: 'KILOGRAMOS', abreviatura: 'KGM', convercion: 2.018 }
        }
        if (formData.value.preProducto.presentacion.idPresentacion === 15) {
          formData.value.preUnidadMedida = { descripcion: 'LITRO', abreviatura: 'LTR', convercion: 2.018 }
        }
      }
      Vue.nextTick(() => {
        const inputCantidad = document.querySelector('#prePrecio')
        if (inputCantidad) {
          inputCantidad.focus()
        }
        if (userData.value?.authorities?.[0]?.authority === 'VENDEDOR GASOCENTRO') {
          const inputImporte = document.querySelector('#preImporte')
          if (inputImporte) {
            inputImporte.focus()
          }
        }
      })
    }
    const changeunidadMedida = () => {
      console.log('unidad')
    }
    const cleanPreData = () => {
      formData.value.preCantidad = null
      formData.value.prePrecio = null
      formData.value.preImporte = null
      formData.value.preProducto = {}
    }
    const searchKey = row => {
      let seacrh = ''
      items.value.forEach((value, index) => {
        if (row.idProducto === value.idProducto) {
          seacrh = index
        }
      })
      return seacrh
    }
    const calcularSubtotal = () => {
      let subtotal = 0
      let subigv = 0
      items.value.forEach(value => {
        console.log(value)
        subtotal += parseFloat(value.subtotal)
        subigv += parseFloat(value.igv)
      })
      formData.value.igv = parseFloat(subigv).toFixed(2)
      formData.value.total = parseFloat(subtotal).toFixed(2)
      formData.value.subTotal = parseFloat(subtotal - subigv).toFixed(2)
      calcularVuelto()
    }
    const addDetalle = () => {
      try {
        // const valPro = formData.value.preProducto === null
        // console.log({ valPro })
        // console.info(formData.value.preProducto, formData.value.preCantidad, formData.value.prePrecio)
        console.info(formData.value.preCantidad)
        // VALIDAR CANTIDAD
        if (userData.value?.authorities?.[0]?.authority === 'VENDEDOR GASOCENTRO') {
          if (formData.value.preImporte === '' || formData.value.preImporte === 0 || formData.value.preImporte === '0' || formData.value.preImporte === undefined) {
          // formData.value.preCantidad.focus()
            throw new Error('TIENE QUE INGRESAR EL IMPORTE')
          }
          formData.value.preCantidad = parseFloat(formData.value.preImporte / formData.value.prePrecio).toFixed(3)
        }
        if (formData.value.preProducto === '' || formData.value.preProducto === 0 || formData.value.preProducto === undefined || formData.value.preProducto === null) {
          // formData.value.preCantidad.focus()
          throw new Error('TIENE QUE SELECCIONAR UN PRODUCTO')
        }
        if (formData.value.preCantidad === '' || formData.value.preCantidad === 0 || formData.value.preCantidad === '0' || formData.value.preCantidad === undefined || formData.value.preCantidad === null) {
          // formData.value.preCantidad.focus()
          throw new Error('TIENE QUE INGRESAR LA CANTIDAD')
        }
        // VALIDAR PRECIO
        if (formData.value.prePrecio === '' || formData.value.prePrecio === 0 || formData.value.prePrecio === '0' || formData.value.prePrecio === undefined || formData.value.prePrecio === null) {
          formData.value.prePrecio.focus()
          throw new Error('TIENE QUE INGRESAR EL PRECIO')
        }
        let subTotalGenerado = parseFloat(formData.value.prePrecio * formData.value.preCantidad).toFixed(2)
        if (userData.value?.authorities?.[0]?.authority === 'VENDEDOR GASOCENTRO') {
          subTotalGenerado = parseFloat(formData.value.preImporte).toFixed(2)
        }
        // VALIDAR SI EXISTE EL PRODUCTO
        let rowPrecioVenta = formData.value.prePrecio
        let rowPrecioVentaCompleto = formData.value.prePrecio
        if (isIgv.value) {
          rowPrecioVentaCompleto = parseFloat(formData.value.prePrecio / 1.18)
          rowPrecioVenta = rowPrecioVentaCompleto.toFixed(5)
        }
        let rowIgv = 0
        if (userData.value.authorities[0].authority === 'CONTADOR') {
          const sub = parseFloat(rowPrecioVentaCompleto * formData.value.preCantidad).toFixed(2)
          if (isIgv.value) {
            rowIgv = sub * 0.18
          }
        }
        console.log(formData.value.preProducto)
        const row = {
          ...formData.value.preProducto,
          precio: formData.value.prePrecio,
          precioVenta: rowPrecioVenta,
          precioVentaCompleto: rowPrecioVentaCompleto,
          cantidad: formData.value.preCantidad,
          subtotal: subTotalGenerado,
          igv: rowIgv,
          key: (items.value.length) === 0 ? 0 : (items.value.length + 1),
          unidadMedida: formData.value.preUnidadMedida,
          isService: false }

        if (userData.value.authorities[0].authority === 'CONTADOR' || userData.value.authorities[0].authority === 'VENDEDOR GASOCENTRO' || userData.value.authorities[0].authority === 'VENDEDOR GRANEL') {
          row.productoNombre = row.presentacion.descripcion
        }
        if (searchKey(row) !== '') {
          throw new Error('EL PRODUCTO YA FUE AGREDADO')
        }
        console.log({ row })
        items.value.push(row)
        formData.value.preUnidadMedida = []
        formData.value.preCantidad = null
        cleanPreData()
        formData.value.preProducto = null
        calcularSubtotal()
        notify('', 'Se agrego el detalle', 'success')
        Vue.nextTick(() => {
          const inputEfectivo = document.querySelector('#efectivo')
          if (inputEfectivo) {
            inputEfectivo.focus()
          }
        })
      } catch (error) {
        console.log(error)
        notify('Error', error.message, 'danger')
      }
    }
    const addDetalleLibre = () => {
      const row = {
        productoNombre: '',
        precio: parseFloat(0).toFixed(2),
        cantidad: parseFloat(0).toFixed(2),
        igv: parseFloat(0).toFixed(2),
        subtotal: parseFloat(0).toFixed(2),
        key: (items.value.length) === 0 ? 0 : (items.value.length + 1),
        unidadMedida: { descripcion: 'SERVICIO', abreviatura: 'ZZ', convercion: 1 },
        isService: true }
      if (searchKey(row) !== '') {
        throw new Error('EL PRODUCTO YA FUE AGREDADO')
      }
      console.log({ row })
      items.value.push(row)
      calcularSubtotal()
    }
    const deleteDetalle = row => {
      items.value.forEach((value, index) => {
        if (row.idProducto === value.idProducto) {
          items.value.splice(index, 1)
        }
      })
      calcularSubtotal()
    }
    const changeCantidadPrecio = (row, tipo) => {
      console.info(row, tipo, items)
      items.value.forEach((element, index) => {
        if (element.key === row.key) {
          if (tipo === 'PV') {
            if (isIgv.value) {
              items.value[index].precio = parseFloat((items.value[index].precioVenta / 1.18)).toFixed(2)
            } else {
              items.value[index].precio = parseFloat((items.value[index].precioVenta)).toFixed(2)
            }
          }

          if (tipo === 'P') {
            if (isIgv.value) {
              items.value[index].precioVenta = parseFloat(items.value[index].precio * 1.18).toFixed(2)
            } else {
              items.value[index].precioVenta = parseFloat(items.value[index].precio).toFixed(2)
            }
          }
          items.value[index].subtotal = parseFloat(row.cantidad * row.precio).toFixed(2)

          if (userData.value.authorities[0].authority === 'CONTADOR') {
            const sub = parseFloat(row.cantidad * row.precio).toFixed(2)
            if (isIgv.value) {
              items.value[index].igv = sub * 0.18
            }
          }
        }
      })
      calcularSubtotal()
      // row.subtotal = parseFloat(row.cantidad * row.precio).toFixed(2)
    }
    const getFechaVencimiento = () => {
      isVencimiento.value = false
      if (formData.value.tipoVenta.tipoVentaId === 1) {
        isVencimiento.value = true
      }
    }
    const changeTipoPago = async () => {
      console.log(formData.value.tipoPago)
      console.log(formData.value.cliente)
      isFise.value = true
      if (formData.value.tipoPago.descripcion === 'BONO_FISE') {
        isFise.value = false
        if (formData.value.cliente != null && formData.value.cliente !== 0) {
          await getsaldoCliente(formData.value.cliente.idCliente)
        }
      } else {
        formData.value.cantidadFise = 0
      }
    }
    const onSearchClienteFinal = async searchTerm => {
      // console.log({ searchTerm })
      if (!searchTerm || searchTerm.length < 2) {
        selectClienteFinal.value = []
        return
      }

      loadingClienteFinal.value = true

      try {
        await store
          .dispatch('comercial/CLIENTE_FIND_ALL', {
            idEmpresa: '-1',
            limit: 10,
            query: searchTerm,
            page: 1,
            sortBy: 'idCliente%7CDESC',
            tipoProducto: 'CILINDRO',
          })
          .then(response => {
            selectClienteFinal.value = response.items
          })
          .catch(error => {
            notify('Error', error.message, 'danger')
          })
      } catch (error) {
        console.error('Error al buscar clientes:', error)
      } finally {
        loadingClienteFinal.value = false
      }
    }
    const onSearchCliente = async searchTerm => {
      // console.log({ searchTerm })
      if (!searchTerm || searchTerm.length < 2) {
        selectCliente.value = []
        return
      }

      loadingCliente.value = true

      try {
        await store
          .dispatch('comercial/CLIENTE_FIND_ALL', {
            idEmpresa: '-1',
            limit: 10,
            query: searchTerm,
            page: 1,
            sortBy: 'idCliente%7CDESC',
            tipoProducto: 'CILINDRO',
          })
          .then(response => {
            selectCliente.value = response.items
          })
          .catch(error => {
            notify('Error', error.message, 'danger')
          })
      } catch (error) {
        console.error('Error al buscar clientes:', error)
      } finally {
        loadingCliente.value = false
      }
    }
    const selectedCliente = () => {
      // console.log(formData.value.cliente)

      formData.value.razon_social = formData.value.cliente.razonSocial
      formData.value.direccion = formData.value.cliente.direccion
      formData.value.documentoCliente = formData.value.cliente.documento
      formData.value.celular = formData.value.cliente.celular
      // FACTURAS
      if (formData.value.documentoCliente.length === 11) {
        selectTipoDocumento.value.forEach(row => {
          if (row.tipoDocumentoId === 1) {
            formData.value.tipoDocumento = row
          }
        })
        getSeries(formData.value.tipoDocumento)
      }
      // BOLETAS
      if (formData.value.documentoCliente.length === 8) {
        selectTipoDocumento.value.forEach(row => {
          if (row.tipoDocumentoId === 2) {
            formData.value.tipoDocumento = row
          }
        })
        getSeries(formData.value.tipoDocumento)
      }
    }
    const leapInput = id => {
      console.log(id)
      Vue.nextTick(() => {
        const inputEfectivo = document.querySelector(`#${id}`)
        if (inputEfectivo) {
          inputEfectivo.focus()
        }
      })
    }
    const formatDate = date => {
      if (!date) return ''
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}-${month}-${year}`
    }
    const isVendedorGasocentro = computed(() => userData.value?.authorities?.[0]?.authority === 'VENDEDOR GASOCENTRO')
    const fechaMaxima = computed(() => moment().format('YYYY-MM-DD'))

    const fechaMinima = computed(() => moment().subtract(3, 'days').format('YYYY-MM-DD'))
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)
    getParametros()
    return {
      formData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      titleForm,
      getParametros,
      presentaciones,
      presentacionSel,
      selectVendedor,
      selectTipoVenta,
      selectFormaPago,
      selectTipoDocumento,
      selectSerie,
      getSeries,
      getNroComprobante,
      selectFormaPrint,
      getSearchDocument,
      selectProducto,
      selectunidadMedida,
      fieldsDetalle,
      changeProducto,
      items,
      sortBy,
      isBusy,
      addDetalle,
      addDetalleLibre,
      cleanPreData,
      calcularSubtotal,
      deleteDetalle,
      changeCantidadPrecio,
      searchKey,
      formParse,
      changeunidadMedida,
      userProfile,
      userData,
      calcularVuelto,
      isVencimiento,
      getFechaVencimiento,
      calcularCantidadGranel,
      isCalcular,
      calculoGranel,
      selectTipoPago,
      changeTipoPago,
      isFise,
      selectClienteFinal,
      getsaldoCliente,
      buscarCliente,
      loadingClienteFinal,
      onSearchClienteFinal,
      imprimirPDF,
      selectCliente,
      loadingCliente,
      onSearchCliente,
      selectedCliente,
      isVendedorGasocentro,
      modalidad,
      leapInput,
      isIgv,
      isVentaExterna,
      formatDate,
      fechaMaxima,
      fechaMinima,
      getFechaConHoraActual,
      tienePerfil,
      getPrintPdfTicke,
      convertirNumeroALetras,
    }
  },
}
</script>

<style>
.black-text label,
.black-text input {
  color: black !important;
}
</style>
